import isDocumentContent from "./isDocumentContent";
import isDocumentMapDataGeometry from "./isDocumentMapDataGeometry";
import isDocumentMapDataPoint from "./isDocumentMapDataPoint";
import isEdgeSource from "./isEdgeSource";
import isNodeSource from "./isNodeSource";
export default (item) => {
    var _a;
    return (isNodeSource(item) && item.Created) ||
        (isEdgeSource(item) && item.Created) ||
        (isDocumentMapDataPoint(item) && ((_a = item.NodeSource) === null || _a === void 0 ? void 0 : _a.Created)) ||
        (isDocumentMapDataGeometry(item) && item.Created) ||
        (isDocumentContent(item) && item.Created) ||
        undefined;
};
